import React from 'react';

import { Controller, FieldError, UseControllerOptions } from 'react-hook-form';

import { TextField } from '@material-ui/core';
import { Autocomplete, AutocompleteRenderInputParams } from '@material-ui/lab';

type InputProps<T> = UseControllerOptions & {
  label: string;
  required?: boolean;
  error?: FieldError;
  className?: string;
  options: Array<T>;
  getOptionLabel: (option: T) => string;
  renderInput?: (params: AutocompleteRenderInputParams) => React.ReactNode;
  defaultValue?: T;
  disabled?: boolean;
};

export const FormAutocomplete = <T extends any>({
  name,
  label,
  control,
  error,
  required,
  className,
  rules,
  options,
  getOptionLabel,
  renderInput,
  defaultValue,
  disabled,
}: InputProps<T>) => (
  <Controller
    className={className}
    name={name}
    control={control}
    defaultValue={defaultValue}
    onChange={([, data]: Array<T>) => data}
    rules={{
      ...rules,
      required: required || rules?.required ? 'Required' : false,
    }}
    render={({ onChange, ...props }) => (
      <Autocomplete
        options={options}
        getOptionLabel={getOptionLabel}
        disabled={disabled}
        renderInput={(params) =>
          renderInput || (
            <TextField
              error={Boolean(error)}
              helperText={error?.message}
              required={Boolean(required || rules?.required)}
              {...params}
              label={label}
            />
          )
        }
        onChange={(_e, data) => onChange(data)}
        {...props}
      />
    )}
  />
);
